<template>
    <div>
        <div class="content-box">
            <el-form ref="form" label-width="100px" :model="formItem" v-loading="formLoading"  :rules="rules" class="form-wrap">
                <el-form-item label="媒体：" prop="plat_id">
                    <ESelect v-model="formItem.plat_id" @change="changePlat" :disabled="isEdit" filterable clearable class="full-w" placeholder="请选择媒体">
                        <el-option
                            v-for="item in platList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="素材类型：" prop="type">
                    <!--<el-radio-group v-model="formItem.type" :disabled="isEdit" @change="changeType">-->
                        <!--<el-radio label="1">图片</el-radio>-->
                        <!--<el-radio label="2">视频</el-radio>-->
                    <!--</el-radio-group>-->

                    <ESelect v-model="formItem.type" :disabled="isEdit" filterable class="full-w" @change="changeType" placeholder="请选择素材类型">
                        <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="投放场景：" prop="delivery_scene">
                    <ESelect v-model="formItem.delivery_scene" :disabled="isEdit" :loading="deliverySceneLoading" @change="changeDeliveryScene" filterable clearable class="full-w" placeholder="请选择投放场景">
                        <el-option
                            v-for="item in deliverySceneList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="投放版位：" prop="delivery_scene">
                    <ESelect v-model="formItem.delivery_type" :disabled="isEdit" :loading="deliveryTypeLoading" filterable clearable class="full-w" placeholder="请选择投放版位">
                        <el-option
                            v-for="item in deliveryTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="任务明细：">
                    <el-table
                        size="mini"
                        :data="formItem.detail"
                        border
                        :header-cell-style="{background:'#e8eaec',color:'#333',padding:0,}"
                        :default-sort = "{prop: 'log_time', order: 'descending'}"
                        class="mt4 full-w"
                        :row-class-name="tableRowClassName"
                    >
                        <el-table-column
                            prop="action"
                            label="操作"
                            align="center"
                            width="100">
                            <template slot-scope="scope">
                                <span v-if="getIsRepeat(scope.row,scope.$index)" class="text-color-error el-icon-warning-outline"></span>
                                <span v-if="scope.row.mark" class="text-color-error el-icon-magic-stick"></span>
                                <span @click="addRow(scope.row,scope.$index)" class="el-icon-circle-plus pointer text-color-primary font16px ml2 mr2" title="添加一行"></span>
                                <span @click="copyRow(scope.$index)" class="el-icon-document-copy pointer font16px ml2 mr2" title="复制"></span>
                                <span v-if="isNotNeedConfirm(scope.row)" @click="deleteRow(scope.$index)" class="el-icon-remove pointer text-color-error font16px ml2 mr2" title="删除"></span>
                                <el-popconfirm
                                    v-else
                                    title="您确定要删除吗？"
                                    confirm-button-text="删除"
                                    confirm-button-type="danger"
                                    @confirm="deleteRow(scope.$index)">
                                    <span slot="reference" class="el-icon-remove pointer text-color-error font16px ml2 mr2" title="删除"></span>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="size"
                            label="素材尺寸"
                            align="center"
                            width="180">
                            <template slot="header">
                                <span class="text-color-error pr4">*</span>素材尺寸
                            </template>
                            <template slot-scope="scope">
                                <el-input-number size="mini" :controls="false" :value="scope.row.width" @change="(val)=>changeWidth(val,scope.$index)" style="width:70px;"></el-input-number> *
                                <el-input-number size="mini" :controls="false" :value="scope.row.height" @change="(val)=>changeHeight(val,scope.$index)" style="width:70px;"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="material_format"
                            label="素材格式"
                            align="center"
                            min-width="180">
                            <template slot="header">
                                <span class="text-color-error pr4">*</span>素材格式
                            </template>
                            <template slot-scope="scope">
                                <ESelect :value="scope.row.material_format" @change="(val)=>changeFormat(val,scope.$index)" filterable multiple size="mini" class="full-w remote-select-tags-width" placeholder="请选择">
                                    <el-option
                                        v-for="item in (formItem.type=='1'?formatImage:formatVideo)"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        {{item}}
                                    </el-option>
                                </ESelect>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="material_size_unit"
                            label="素材大小"
                            align="center"
                            width="165">
                            <template slot="header">
                                <span class="text-color-error pr4">*</span>素材大小
                            </template>
                            <template slot-scope="scope">
                                <el-input placeholder="素材大小" :value="scope.row.material_size" @input="(val)=>changeSize(val,scope.$index)" class="input-with-select" size="mini">
                                    <el-button slot="prepend" size="mini">⩽</el-button>
                                    <el-select :value="scope.row.material_size_unit" @change="(val)=>changeUnit(val,scope.$index)" slot="append" size="mini" placeholder="" style="width:70px;">
                                        <el-option label="KB" value="KB"></el-option>
                                        <el-option label="MB" value="MB"></el-option>
                                    </el-select>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="formItem.type=='2'"
                            prop="material_duration"
                            label="素材时长"
                            align="center"
                            width="140">
                            <template slot="header">
                                <span class="text-color-error pr4">*</span>素材时长
                            </template>
                            <template slot-scope="scope">
                                <el-input-number size="mini" :controls="false" :value="scope.row.material_duration" @change="(val)=>changeDuration(val,scope.$index)" style="width:70px;"></el-input-number> 秒
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item prop="detail"></el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="submitLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<script>
    import {uniq,cloneDeep,isEqualArray,isEqual, uniqWith, uniqBy} from "lodash";
    import API from '@/api/workOrder/conf.js';
    export default {
        name: "SizeRuleModal",
        props:{
            // platList:Array,
            id:[String,Number],
            detail:Array,
            cbs:{
                type:Object,
            },

        },
        data(){
            let _this = this;
            const validateDetail = (rule, value, callback) => {
                if(!this.formItem.type)  return callback(new Error('请先选择素材类型'));
                let detailList = _this.formItem.detail||[];
                let errText = _this.checkDetailError(detailList);

                if(errText.length>0){
                    return callback(new Error(errText));
                }else{
                    let newList = cloneDeep(detailList).map(item=>''+item.width+item.height+item.material_size+item.material_duration +item.material_size_unit+item.material_format.join(','));
                    if(uniq(newList).length!=detailList.length){
                        return callback(new Error('任务明细存在重复项，请检查'));
                    }else{
                        callback();
                    }
                }
            };

            return {
                formLoading:false,
                submitLoading:false,
                groupLoading:false,
                formItem:{
                    plat_id:'',
                    type:'1',
                    delivery_scene:'',
                    delivery_type:'',
                    detail:[],
                },
                rules:{
                    plat_id:[
                        { required: true, message: '请选择媒体', trigger: 'change' },
                    ],
                    type:[
                        { required: true, message: '请选择素材类型', trigger: 'change' },
                    ],
                    delivery_scene:[
                        { required: true, message: '请选择投放场景', trigger: 'change' },
                    ],
                    delivery_type:[
                        { required: true, message: '请选择投放版位', trigger: 'change' },
                    ],
                    detail:[
                        { type: 'array', required: true, message: '请填写任务明细', trigger: 'change' },
                        { validator: validateDetail, trigger: 'blur' },
                    ],
                },
                appTypeList:[
                    {id:'1',name:'游戏',},
                    {id:'2',name:'应用',},
                ],
                typeList:[
                    {id:'1',name:'图片',},
                    {id:'2',name:'视频',},
                ],
                deliverySceneList:[],
                deliveryTypeList:[],
                baseConfig:{
                    width:undefined,
                    height:undefined,
                    material_format:[],
                    material_size:'',
                    material_size_unit:'KB',
                    material_duration:undefined,
                },
                formatImage:[],
                formatVideo:[],
                deliverySceneLoading:false,
                deliveryTypeLoading:false,
                platList:[],
                some_list:[],  // 重复项目收集
            }
        },
        computed:{
            isEdit(){
                return !!this.id;
            },
        },
        mounted(){
            this.getSizeConfigPlatList();
            Promise.all([
                this.getMaterialFormat('1'),
                this.getMaterialFormat('2'),
            ]).then(()=>{
                if(!this.id){
                    this.formItem.type = '1';
                    this.setDefaultRow();
                }else {
                    this.getRuleInfo();
                }
            });
        },
        methods:{
            getMaterialFormat(val){
                return API.getMaterialFormat({
                    type:val,
                }).then(res=>{
                    console.log('getMaterialFormat',res);
                    let resData = res.data||[];
                    if(val=='1'){
                        this.formatImage = resData;
                    }else{
                        this.formatVideo = resData;
                    }
                },err=>{
                    console.log('getMaterialFormat err',err);
                })
            },
            getSizeConfigPlatList(){
                API.getSizeConfigPlatList().then(res=>{
                    this.platList = (res.data||[]).map(item=>{
                        return {
                            id:item.plat_id,
                            name:item.plat_name,
                        }
                    })
                })
            },
            tableRowClassName({row, rowIndex}) {
                if(this.some_list.includes(rowIndex)) {
                    return 'warning-row';
                }
                return  ''
            },
            /**
             * 数组对象 指定属性是否重复 收集重复的数组
             *
             * */
            findDuplicateArrays(arr) {
                let seenCombinations = new Map();
                let duplicates = [];
                let clone_deep_arr = cloneDeep(arr)
                clone_deep_arr.forEach((obj, index) => {

                    let combination = obj.width + '-' + obj.height + '-' + obj.material_size + '-' + obj.material_size_unit + '-' + obj.material_duration + '-' + obj.material_format.sort().join(',');

                    if (seenCombinations.has(combination)) {
                        duplicates.push({
                            index: index,
                            indices: [seenCombinations.get(combination)]
                        });
                    } else {
                        seenCombinations.set(combination, index);
                    }
                });

                return duplicates;
            },
            submitModal(){
                console.log('submitModal');
                this.$refs.form.validate((valid) => {
                    if(valid){
                        let reqData = {
                            plat_id:this.formItem.plat_id,
                            type:this.formItem.type,
                            delivery_scene:this.formItem.delivery_scene,
                            delivery_type:this.formItem.delivery_type,
                            detail:this.formItem.detail.map(item=>{
                                return {
                                    width:item.width,
                                    height:item.height,
                                    material_format:item.material_format,
                                    material_size:item.material_size,
                                    material_size_unit:item.material_size_unit,
                                    material_duration:item.material_duration,
                                }
                            }),
                        };
                        if(this.id){
                            reqData.id = this.id;
                        }
                        this.submitLoading = true;
                        let APIType = this.id?'updateSizeConfig':'saveSizeConfig';
                        API[APIType](reqData).then(res=>{
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.cbs.onSubmit('update');
                            this.hideModal();
                        },err=>{
                            this.submitLoading = false;

                            if (err.code == '403') {
                                this.$confirm(err.info||'请求异常', '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }

                            let errData = err.data||{};
                            if(errData.rule_id){
                                this.$confirm(`当前规则与规则ID${errData.rule_id} 重复，是否继续？继续后会将尺寸信息合并至该规则。`, '提示', {
                                    confirmButtonText: '继续',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    // this.cbs.onEdit(errData.rule_id,this.formItem.detail);
                                    // this.$emit('close')
                                    this.submitLoading = true;
                                    API.updateSizeConfig({
                                        id:errData.rule_id,
                                        plat_id:this.formItem.plat_id,
                                        type:this.formItem.type,
                                        delivery_scene:this.formItem.delivery_scene,
                                        delivery_type:this.formItem.delivery_type,
                                        detail:[],
                                        new_detail:this.formItem.detail.map(item=>{
                                            return {
                                                width:item.width,
                                                height:item.height,
                                                material_format:item.material_format,
                                                material_size:item.material_size,
                                                material_size_unit:item.material_size_unit,
                                                material_duration:item.material_duration,
                                            }
                                        }),
                                    }).then(res1=>{
                                        this.submitLoading = false;
                                        this.$message.success(res1.info||'操作成功');
                                        this.cbs.onSubmit('update');
                                        this.hideModal();
                                    },err1=>{
                                        this.submitLoading = false;
                                        this.$message.error(err1.info||'操作失败');
                                    });
                                }).catch(() => {
                                });

                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        })
                    }else{
                        console.log('error submit!!');

                        let noSome = this.findDuplicateArrays(this.formItem.detail) //true 通过 false 有相同
                        this.some_list = noSome.map(item=>item.index)

                        return false;
                    }
                });
            },
            hideModal(){
                this.$emit('close');
            },
            setDefaultRow(){
                let baseConfig = cloneDeep(this.baseConfig);
                baseConfig.material_format = this.formItem.type=='1'?this.formatImage.map(item=>item):this.formatVideo.map(item=>item);

                this.formItem.detail = [baseConfig];
            },
            getRuleInfo(){
                this.formLoading = true;
                API.getSizeConfigInfo({
                    id: this.id,
                }).then(res=>{
                    console.log('getSizeConfigInfo',res);
                    let resData = res.data||{};
                    this.formItem.plat_id = resData.plat_id;
                    this.formItem.type = resData.type;
                    this.formItem.delivery_scene = resData.delivery_scene;
                    this.formItem.delivery_type = resData.delivery_type;
                    this.formItem.detail = resData.detail||[];
                    this.formLoading = false;
                    this.getDeliverySceneOptions();
                    this.getDeliveryTypeOptions();

                    let detail = this.detail||[];
                    if(detail.length>0){
                        this.formItem.detail = this.formItem.detail.concat([...detail].map(item=>{
                            item.mark = true;
                            return item;
                        }));
                    }
                },err=>{
                    console.log('getSizeConfigInfo err',err);
                    this.formLoading = false;
                })
            },
            changePlat(val){
                console.log('changePlat',val);
                this.getDeliverySceneOptions();
                this.formItem.delivery_scene = '';
                this.formItem.delivery_type = '';
            },
            changeType(val){
                console.log('changeType',val);
                this.baseConfig.material_size_unit = val=='1'?'KB':'MB';
                let typeConfig = val=='1'?this.formatImage.map(item=>item):this.formatVideo.map(item=>item);
                this.baseConfig.material_format = typeConfig;

                this.formItem.detail.forEach(item=>{
                    if(val=='1'){
                        // 图片，把明细列表的时长删除
                        item.material_duration = undefined;
                    }
                    item.material_format = typeConfig.map(item=>item);
                    item.material_size_unit = val=='1'?'KB':'MB';
                });
            },
            getDeliverySceneOptions(){
                this.deliverySceneLoading = true;
                API.getDeliveryOptions({
                    plat_id:this.formItem.plat_id,
                    search_type:'delivery_scene',     //delivery_scene投放场景 delivery_type投放版位
                }).then(res=>{
                    console.log('getDeliverySceneOptions',res);
                      this.deliverySceneLoading = false;
                      this.deliverySceneList = (res.data||[]).map(item=>{
                          return {
                              id:item.delivery_scene_id,
                              name:item.delivery_scene,
                          }
                      });
                },err=>{
                    console.log('getDeliverySceneOptions err',err);
                      this.deliverySceneLoading = false;
                    this.deliverySceneList = [];
                })
            },
            changeDeliveryScene(val){
                console.log('changeDeliveryScene',val);
                this.getDeliveryTypeOptions();
                this.formItem.delivery_type = '';
            },
            getDeliveryTypeOptions(){
                if(!this.formItem.delivery_scene) return;
                this.deliveryTypeLoading = true;
                API.getDeliveryOptions({
                    plat_id:this.formItem.plat_id,
                    search_type:'delivery_type',     //delivery_scene投放场景 delivery_type投放版位
                    delivery_scene_id:this.formItem.delivery_scene,
                }).then(res=>{
                    console.log('getDeliveryTypeOptions',res);
                    this.deliveryTypeLoading = false;
                    this.deliveryTypeList = (res.data||[]).map(item=>{
                        return {
                            id:item.delivery_type_id,
                            name:item.delivery_type,
                        }
                    });
                },err=>{
                    console.log('getDeliveryTypeOptions err',err);
                    this.deliveryTypeLoading = false;
                    this.deliveryTypeList = [];
                })
            },




            addRow(row,index){
                console.log('addRow',row,index);
                let length = this.formItem.detail.length;
                if(length>500){
                    return this.$message.error('素材明细最多添加500条');
                }
                this.formItem.detail.splice(index+1, 0, {...this.baseConfig});
            },
            copyRow(index){
                console.log('copyRow',index);
                let data = {...this.formItem.detail[index]};
                data.id='';
                this.formItem.detail.push(data);
            },
            deleteRow(index){
                console.log('deleteRow',index);
                if(this.formItem.detail.length<=1){
                    return this.$message.error('不能再删了……');
                }
                this.formItem.detail.splice(index,1);
            },
            isNotNeedConfirm(row){
                if(this.formItem.detail.length==1){
                    return true;
                }
                return !(row.width||row.height||row.material_size||row.material_duration||(row.material_format||[]).length>0);
            },
            getIsRepeat(row,index){
                return false;
                let allList = cloneDeep(this.formItem.detail);
                let repeatIndex = [];
                allList.forEach((item,i)=>{
                    let isSameFormat = isEqualArray(item.material_format,row.material_format);
                    if(isSameFormat&&item.width===row.width&&item.height===row.height&&item.material_size===row.material_size&&item.material_size_unit===row.material_size_unit&&item.material_duration===row.material_duration){
                        repeatIndex.push(i);
                    }
                });
                return !repeatIndex.splice(0,1).includes(index);
            },
            changeWidth(val,index){
                console.log('changeWidth',val,index);
                this.formItem.detail[index].width = val;
            },
            changeHeight(val,index){
                console.log('changeHeight',val,index);
                this.formItem.detail[index].height = val;
            },
            changeSize(val,index){
                console.log('changeSize',val,index);
                this.formItem.detail[index].material_size = val;
            },
            changeFormat(val,index){
                console.log('changeFormat',val,index);
                this.formItem.detail[index].material_format = val;
            },
            changeUnit(val,index){
                console.log('changeUnit',val,index);
                this.formItem.detail[index].material_size_unit = val;
            },
            changeDuration(val,index){
                console.log('changeDuration',val,index);
                this.formItem.detail[index].material_duration = val;
            },
            checkDetailError(detailList){
                let errText = '';
                for (let i = 0; i < detailList.length; i++) {
                    let item = detailList[i];
                    if(!item.width||!item.height){
                        errText = '第'+(i+1)+'行：素材尺寸需大于0';
                        break;
                    }else if(item.width<=0||item.height<=0){
                        errText = '第'+(i+1)+'行：素材尺寸需大于0';
                    }else if(item.width>9999||item.height>9999){
                        errText = '第'+(i+1)+'行：素材尺寸最多支持4位数';
                        break;
                    }else if(item.width%1>0||item.height%1>0){
                        errText = '第'+(i+1)+'行：素材尺寸不支持小数';
                        break;
                    }else if(item.material_format.length<=0){
                        errText = '第'+(i+1)+'行：素材格式不能为空';
                        break;
                    }else if(!item.material_size){
                        errText = '第'+(i+1)+'行：素材大小不能为空';
                        break;
                    }else if(item.material_size<=0){
                        errText = '第'+(i+1)+'行：素材大小需大于0';
                        break;
                    }else if(this.formItem.type=='2'){
                        if(!item.material_duration){
                            errText = '第'+(i+1)+'行：视频时长不能为空';
                            break;
                        }else if(item.material_duration<=0||+item.material_duration%1>0){
                            errText = '第'+(i+1)+'行：视频时长仅支持正整数';
                            break;
                        }else if(item.material_duration>999){
                            errText = '第'+(i+1)+'行：视频时长不能大于3位数';
                            break;
                        }
                    }
                }
                return errText;
            },
        }
    }
</script>

<style lang="scss" scoped>
.content-box .form-wrap{

    max-height: 400px;
    overflow-y: auto;
    padding-right: 60px;

    ::v-deep.el-table .warning-row {
        background: oldlace;
    }
    /* 修正input prepend显示的小竖杠 */
    ::v-deep .el-input-group__prepend{
        padding: 0 10px;
        &::after{
            display: none;
        }
    }
    ::v-deep .el-input-group__append{
        padding: 0 15px;
        .el-select {
            width: 60px!important;
            .el-input--suffix .el-input__inner{
                padding: 0 15px;
            }
        }
    }

    ::v-deep .el-table .cell{
        line-height: 32px;
        min-height:32px!important;
        padding-left: 6px;
        padding-right: 6px;
    }
}
</style>
